import React from "react";
import "./Legend.scss";

const LegendSwitch = ({ title, onClick }) => {
  return (
    <div className="legend-switch-container" onClick={onClick}>
      <div className="title">
        {title === "Consumo" ? "Média móvel" : "Consumo"}
      </div>
    </div>
  );
};

export default LegendSwitch;
